import React from "react";
import "./aboutContent.css";
// import mestryAbout from "../../../assets/paipage1.png";
import mestryAbout from "../../../assets/newImg/paipage8.png";
const AboutContent = () => {
  return (
    <div className=" ">
      <div className="container aboutContentBg my-xl-5 my-lg-5 my-3">
        <div className="row d-flex justify-content-around">
          <div className="col-md-6 col-sm-12 col-lg-6 my-xl-5 my-lg-5 my-md-4 my-sm-3 my-3 ">
            <h3 className="abtContenth1  ">
              Why <span className="abtBanHeading">Mestry Circle?</span>
            </h3>
            <h6 className="abtcontentP2 mobileDflex">
              Building a home should feel exciting —not exhausting.
            </h6>
            <p className="abtcontentP">
              Many people spend months visiting places, meeting vendors, and
              still struggle to find skilled technicians
            </p>
            <p className="abtcontentP">
              Even after all that effort, you often realize too late that the
              vendor's skill, experience or quality doesn't match our
              expectations-causing delays and disappointment in our dream
            </p>
            <p className="abtcontentP">
              That's why we created Mestry Circle a smart platform where anyone
              can connect with 100+ verified contractors, technicians, and
              material suppliers in just one day. From your home, office, you
              can invite vendors to your site compare options, and discuss
              everything-experience, cost, timeline, and quality.
            </p>
            <p className="abtcontentP">
              With Mestry Circle building your dream home becomes simple,
              transparent, and joyful.
            </p>
            <p className="abtcontentP2">
              More choices. Better people. Real savings.
            </p>
          </div>
          <div className="col-md-4 col-sm-12 col-lg-5 my-xl-5 my-lg-5 my-md-4 my-sm-3 my-3 mobileDflex3  px-sm-5 ">
            <img
              src={mestryAbout}
              alt="mestryAbout"
              className="mestryAboutImg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
